var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.regions.length > 0)?_c('Dropdown',{attrs:{"options":_vm.regions,"disabled":_vm.disabled,"textValue":_vm.displayValue},on:{"select":_vm.selectRegion}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }